import { User } from 'app/types'

export interface CanJoinGroupOptions {
  user: Pick<User, 'userType'> | null
  group?: {
    university?: {
      slug: string
    }
    universityCourse?: {
      slug: string
    }
    allowedUserTypes: string[]
  }
}

/**
 * This is a helper function that determines if a user can join a group.
 *
 *! Ideally we would have these access rules in the GraphQL schema, but this is
 *! a brute force way of doing it for now until we can figure out the exact
 *! access rules for each group, and how they can be configurable.
 *
 * @param options Options used for determining if a user can join a group
 * @returns True if the user can join the group, otherwise false
 */
export const canJoinGroup = (options: CanJoinGroupOptions): boolean => {
  // Only if we have a group can we join it
  if (!options.group) {
    return false
  }

  // Cannot join university groups (done automatically)
  if (!!options.group.university) {
    return false
  }

  // Cannot join university course groups (done automatically)
  if (!!options.group.universityCourse) {
    return false
  }

  // Commenting this out because we get a message from the API if we try to join
  // a group that we are not allowed to join. This is so that we are still able
  // to show the join button!
  // if (!options.group.allowedUserTypes.includes(options.user?.userType || '')) {
  //   return false
  // }

  // Okay, the user can join the group
  return true
}
